import React, { useState } from "react";
import PropTypes from "prop-types";
import { MapInteractionCSS } from "react-map-interaction";

// mui
import Box from "@mui/material/Box";
// component
import CircularProgress from "@mui/material/CircularProgress";
// utils
import { isEmpty } from "../../../../../../../../../common/utils";

const CustomImage = ({ focusItem }) => {
  const [imgScaleValue, setImgScaleValue] = useState({
    scale: 1,
    translation: { x: 0, y: 0 },
  });
  if (isEmpty(focusItem)) return null;

  return (
    <Box
      sx={{
        backgroundColor: " #F7F8FA",
        height: "calc(100% - 45px)",
        position: "sticky",
        zIndex: "1",
      }}
    >
      <MapInteractionCSS
        value={imgScaleValue}
        onChange={(value) => setImgScaleValue(value)}
      >
        {isEmpty(focusItem._imgUrl) ? (
          <CircularProgress />
        ) : (
          <img
            src={focusItem._imgUrl}
            alt={focusItem._imgUrl}
            style={{
              width: "calc(50vh - 10px)",
            }}
          />
        )}
      </MapInteractionCSS>
    </Box>
  );
};

CustomImage.propTypes = {
  focusItem: PropTypes.object,
};

CustomImage.defaultProps = {
  focusItem: {},
};

export default CustomImage;
